export const name = 'linkUtilsService' as const
